import axios from "axios";
import CONSTANTS from "./constants";
import apiEndPoints from "./apiEndPoints";
import getAxiosConfig from "@src/utils/getAxiosConfig";

export const getUpcomingClassesService = async (payload) => {
  return await axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.UPCOMINGCLASSES_LIST_GET]?.method,
      apiEndPoints[CONSTANTS.UPCOMINGCLASSES_LIST_GET]?.url,
      payload
    ),
  });
};

export const getNewServiceUpcomingClassesAndLiveCard = async (payload) => {
  return await axios({
    ...getAxiosConfig(
      apiEndPoints[CONSTANTS.UPCOMINGCLASSES_NEW_SERVICE]?.method,
      apiEndPoints[CONSTANTS.UPCOMINGCLASSES_NEW_SERVICE]?.url,
      payload
    ),
  });
};
